/** Версия протокола. Клиент передаёт её при подключении; несовместимая версия отклоняется. */
export const PROTOCOL_VERSION = 1;
export const CLIENT_TYPES = ['web', 'steam', 'mobile'];
/** События клиент → сервер (SPEC.md, раздел 7.2). */
export const ClientEvent = {
    RoomCreate: 'room:create',
    RoomJoin: 'room:join',
    RoomLeave: 'room:leave',
    RoomReady: 'room:ready',
    RoomSelectRole: 'room:select-role',
    RoomSelectLoadout: 'room:select-loadout',
    MatchRequestStart: 'match:request-start',
    MatchRequestRematch: 'match:request-rematch',
    GameAction: 'game:action',
    CoopSelectPiece: 'coop:select-piece',
    SessionResume: 'session:resume',
};
/** События сервер → клиент (SPEC.md, раздел 7.3). */
export const ServerEvent = {
    RoomCreated: 'room:created',
    RoomJoined: 'room:joined',
    RoomLeft: 'room:left',
    RoomUpdated: 'room:updated',
    RoomError: 'room:error',
    MatchCountdown: 'match:countdown',
    MatchStarted: 'match:started',
    MatchFinished: 'match:finished',
    MatchState: 'match:state',
    MatchRematchStatus: 'match:rematch-status',
    ActionRejected: 'game:action-rejected',
    PlayerConnected: 'player:connected',
    PlayerDisconnected: 'player:disconnected',
    SessionResumed: 'session:resumed',
    ServerError: 'server:error',
};
/** Ошибка при подключении (рукопожатии): передаётся в `connect_error`. */
export const HandshakeError = {
    ProtocolMismatch: 'PROTOCOL_MISMATCH',
    InvalidHandshake: 'INVALID_HANDSHAKE',
};
//# sourceMappingURL=events.js.map